<template>
    <div v-show="display" class="container">
        <div class="loading unselectable"> 
            <div class="box">
                <span>L</span>
                <span>o</span>
                <span>a</span>
                <span>d</span>
                <span>i</span>
                <span>n</span>
                <span>g</span>
                <span>.</span>
                <span>.</span>
                <span>.</span>
            </div>
            <img src="../assets/iCarR.png">
            <div class="background" style="width: 200%; height: 60px; background: #302E2A; top: 100%; position: absolute; display: flex; justify-content: space-around; transform: translateY(-100%);">
                <div style="width: 40px; height: 10px; background: white; top: 10px"></div>
                <div style="width: 40px; height: 10px; background: white; top: 10px"></div>
                <div style="width: 40px; height: 10px; background: white; top: 10px"></div>
                <div style="width: 40px; height: 10px; background: white; top: 10px"></div>
            </div>
        </div>
    </div>
</template>

<script>
export default {
    data(){
        return {
            display: false
        }
    },
    methods: {
        show(){
            this.display = true;
        },
        hide(){
            this.display = false
        }
    }
}
</script>

<style scoped>
.container{
    position: fixed;
    top: 0; left: 0;
    z-index: 3; 
    background: rgba(0,0,0,0.3); 
    width: 100%; height: 100%;
    display: flex; justify-content: center; align-items: center;
}

.loading{
    background: #E8EAED;
    height: 200px;
    width: 200px;
    display: flex; 
    justify-content: center;
    align-items: center;
    border-radius: 50%;
    overflow: hidden;
    position: relative;
}

.loading img{
    width: 75px;
    height: 75px;
    filter: drop-shadow(2px 2px 6px gray);
    animation: shake 1s linear infinite;
    position: absolute;
    z-index: 1;
    top: 35%;
}

.box{
    position: absolute;
    top: 25px;
    color: #888;
}

.box span{
    font-size: 24px;
    position: relative;
    top: 0;
    display: inline-block;
    animation: bounce 0.3s ease infinite alternate;
}

@keyframes bounce{
    100%{
        top: 5px;
    }
}
.box span:nth-child(2){
  animation-delay:0.05s;
}
.box span:nth-child(3){
  animation-delay:0.1s;
}
.box span:nth-child(4){
  animation-delay:0.15s;
}
.box span:nth-child(5){
  animation-delay:0.2s;
}
.box span:nth-child(6){
  animation-delay:0.25s;
}
.box span:nth-child(7){
  animation-delay:0.3s;
}
.box span:nth-child(8){
  animation-delay:0.35s;
}
.box span:nth-child(9){
  animation-delay:0.4s;
}
.box span:nth-child(10){
  animation-delay:0.45s;
}

.word{
    z-index: 2;
    position: absolute;
    top: 20px;
    font-size: 24px;
    color: #555;
    animation: shake 3s linear infinite;
}

.background{
    left: 100%;
    animation: scroll 3s linear infinite;
}

@keyframes scroll {
    0% {
        left: 0;
    }
    100% {
        left: -100%;
    }
}

@keyframes shake {
    0% {
        transform: translateY(0);
    }
    50% {
        transform: translateY(-3px);
    }
    100% {
        transform: translateY(0);
    }
}
</style>